import { BoundingBox, CategorizedData, DisaggregatedMetric, GeoDetails, GeoTag, LayerItem, Location, Metric, MetricMetadata } from "../services/types";

// People
import PopIcon from '../assets/svgr/population.svg?react';
import ForeignBornIcon from '../assets/svgr/foreign-globe.svg?react';
import LimitedEnglishIcon from '../assets/svgr/limited-english.svg?react';
import DisabledIcon from '../assets/svgr/IndividualsWithDisabilities.svg?react';

// Housing
import CostBurdenedIcon from '../assets/svgr/CostBurdenedHouseholds.svg?react';
import ResidentTurnoverIcon from '../assets/svgr/student-mobility.svg?react';
import VacantHousingIcon from '../assets/svgr/house-outline.svg?react';
import HomeOwnershipIcon from '../assets/svgr/homeownership.svg?react';
import HouseIcon from '../assets/svgr/house.svg?react';

// Accessibility
import InternetAccessIcon from '../assets/svgr/internet.svg?react';
import HealthInsuranceIcon from '../assets/svgr/HealthInsuranceRate.svg?react';
import AccessToHouseholdVehicleIcon from '../assets/svgr/vehicle.svg?react';
import SnapIcon from '../assets/svgr/snap.svg?react';

// Education
import GraduationIcon from '../assets/svgr/college.svg?react';
import ChildrenIcon from '../assets/svgr/children.svg?react';

// Economy
import MedHHIcon from '../assets/svgr/annualhhincome.svg?react';
import PovertyIcon from '../assets/svgr/200-poverty-rate.svg?react';
import TwoHundredPovIcon from '../assets/svgr/family.svg?react';
import UnemploymentIcon from '../assets/svgr/unemployment-rate.svg?react';

// #region Organization Metric Mapping
const organizationMetrics: { [orgId: number]: any[] } =
{ 
    // Data Viewer (National using Casey Data)
    54:
    [
        {
            name: "People", // 1072 was Ethnicity - Hispanic / Latino from Casey
            ids: [1072, 1236, 1238, 1237, 1247, 1285],
            order: [
                [1238, 1237, 1236, 1285],
            ],
            charts: [
                {
                    name: "race",
                    id: 1247
                },
            ]
        },
        {
            name: "Accessibility",
            ids: [1253, 1234, 1248, 1257, 1382],
            order: [
                [1234, 1248, 1257, 1382],
            ],
            charts: []
        },
        {
            name: "Housing",
            ids: [1244, 1246, 1245, 1251, 1252, 1092, 1107, 1438],
            order: [
                [1092, 1252, 1251, 1107, 1244, 1438],
            ],
            charts: []
        },
        {
            name: "Education", // Without HS Degree missing in dataviewer (1104)
            ids: [1240, 1239, 1241, 1258],
            order: [
                [1258, 1240, 1239, 1241],
            ],
            charts: []
        },
        {
            name: "Economy",
            ids: [1250, 1242, 1243, 1235],
            order: [
                [1242, 1243, 1235, 1250],
            ],
            charts: []
        },
    ],
    
};

// precisionMapping - maps metricId's to the desired number of significant figures for formatting metric values
export const precisionMapping: { [metricId: number]: number } = {
    // 1125: 1,
    // 1139: 0
};

// Identify metrics included in the index
// Old available id's to test UI
// export const indexMetricIds: number[] = [1234, 1248, 1244, 1242, 1243, 1235, 1239, 1240, 1241, 1246, 1245, 1236, 1285];

// empty ids
export const indexMetricIds: number[] = [];


const svgMap: { [orgId: number]: { [key: number]: string }} =
{
    // Data Viewer (National using Casey Data)
    54: {
    },
    
};

// There are svgs that need to be included in the pdf that are excluded in the dashboard
const pdfSvgMap: { [orgId: number]: { [key: number]: string }} =
{
    // Data Viewer (National using Casey Data)
    54: {
    },
    
};

const svgrMap: { [orgId: number]: { [key: number]: React.FC<React.SVGProps<SVGSVGElement>> }} =
{
    // Data Viewer (National using Casey Data)
    54: {
        1245: CostBurdenedIcon,
        1238: PopIcon,
        1237: ForeignBornIcon,
        1236: LimitedEnglishIcon,
        1251: VacantHousingIcon,
        1252: ResidentTurnoverIcon,
        1234: InternetAccessIcon,
        1235: UnemploymentIcon,
        1242: MedHHIcon,
        1243: PovertyIcon,
        1250: TwoHundredPovIcon,
        1239: GraduationIcon,
        1240: GraduationIcon,
        1241: GraduationIcon,
        1258: ChildrenIcon,
        1285: DisabledIcon,
        1248: HealthInsuranceIcon,
        1257: AccessToHouseholdVehicleIcon,
        1382: SnapIcon,
        1244: HomeOwnershipIcon,
        1438: HouseIcon
    },
};

// There are svgs that need to be included in the pdf that are excluded in the dashboard
const pdfSvgrMap: { [orgId: number]: { [key: number]: React.FC<React.SVGProps<SVGSVGElement>> }} =
{
    // Data Viewer (National using Casey Data)
    54: {
        1245: CostBurdenedIcon,
        1238: PopIcon,
        1237: ForeignBornIcon,
        1236: LimitedEnglishIcon,
        1251: VacantHousingIcon,
        1252: ResidentTurnoverIcon,
        1234: InternetAccessIcon,
        1235: UnemploymentIcon,
        1242: MedHHIcon,
        1243: PovertyIcon,
        1250: TwoHundredPovIcon,
        1239: GraduationIcon,
        1240: GraduationIcon,
        1241: GraduationIcon,
        1258: ChildrenIcon,
        1285: DisabledIcon,
        1248: HealthInsuranceIcon,
        1257: AccessToHouseholdVehicleIcon,
        1382: SnapIcon,
        1244: HomeOwnershipIcon,
        1438: HouseIcon
    },
};

// #endregion


// getMetricGroupIds - get the metric id values for a specific grouping 
export const getMetricGroupIds = (name: string) => {

    let ids = [];
    
    if(organizationMetrics[orgId] != undefined){
        const group: any = organizationMetrics[orgId].find((x: { name: string; }) => x.name === name);

        if(group != undefined){
            ids = group.ids;
        }
    }

    return ids;
}

// Store our organization Id where we can access it later
export let orgId: number = 54;
console.log('current orgId:', orgId);
export const setOrgId = (id: number) => {
    orgId = id;
}

// Store our overlapping county fips codes for BLS and TRS data queries
export var countyId: string[] = [];
export const setCountyIds = (id: string[]) => {
    countyId = id;
}
export const getCountyIds = () => {
    return countyId;
}

// Store our bounding box so we can access it later
export let boundingBox: BoundingBox | null = null;
export const setBoundingBox = (bb: BoundingBox) => {
    boundingBox = bb;
}

// Store our excludeIds so we can access them later
export let excludeIds: string[] | null = null;
export const setExcludeIds = (ids: string[]) => {
    excludeIds = ids;
}

// getSvgMap - get our svg mapping for the given organization and metric id
export const getSvgMap = (id: number) => {
    let svg = "";
    if(svgMap[orgId] != undefined){
        svg = svgMap[orgId][id];
    }
    return svg;
}

// getPdfSvgMap - get our pdf svg mapping for the given organization and metric id
export const getPdfSvgMap = (id: number) => {
    let svg = "";
    if(pdfSvgMap[orgId] != undefined){
        svg = pdfSvgMap[orgId][id];
    }
    return svg;
}

// getSvgMap - get our svg mapping for the given organization and metric id
export const getSvgrMap = (id: number): React.FC<React.SVGProps<SVGSVGElement>> | undefined => {
    if(svgrMap[orgId] != undefined){
        return svgrMap[orgId][id];
    }
    return undefined;
}

// getPdfSvgMap - get our pdf svg mapping for the given organization and metric id
export const getPdfSvgrMap = (id: number): React.FC<React.SVGProps<SVGSVGElement>> | undefined => {
    if(pdfSvgrMap[orgId] != undefined){
        return pdfSvgrMap[orgId][id];
    }
    return undefined;
}

// getMetricGroupOrderIds - get the ordering for a metric group
export const getMetricGroupOrderIds = (name: string) => {
    let orderIds = [];
    
    if(organizationMetrics[orgId] != undefined){
        const group: any = organizationMetrics[orgId].find((x: { name: string; }) => x.name === name);

        if(group != undefined){
            orderIds = group.order;
        }
    }

    return orderIds;
}

// getMetricGroupChartId - get a metric id given the group and chart key
export const getMetricGroupChartId = ( group: string, key: string) => {
    let id = -1;

    if(organizationMetrics[orgId] != undefined){
        const g = organizationMetrics[orgId].find((x: { name: string; }) => x.name === group);
        if(g != undefined){
            
            if(g.charts != undefined){

                const chart = g.charts.find((x: { name: string; }) => x.name === key);
                if(chart != undefined){
                    id = chart.id;
                }
            }
        }
    }

    return id;
}

export const categorizeData = (indicators: DisaggregatedMetric[]) => {

    const categories: { [key: string]: number[] } = {
        Housing: getMetricGroupIds("Housing"),
        Education: getMetricGroupIds("Education"),
        Economy: getMetricGroupIds("Economy"), 
        Accessibility: getMetricGroupIds("Accessibility"),
        People: getMetricGroupIds("People"),
    };

    // Initialize the categorizedData object dynamically with empty arrays for each category
    const categorizedData: Record<string, Metric[]> = Object.keys(categories).reduce((acc, category) => {
        acc[category] = [];
        return acc;
    }, {} as Record<string, Metric[]>);

    // Categorize the indicators dynamically
    indicators.forEach((item) => {
        Object.keys(categories).forEach((category) => {
            if (categories[category].includes(item.id)) {
                categorizedData[category].push(item);
            }
        });
    });

    return categorizedData;
};

export const fetchMetricCategories = async (orgId: number) => {
    if (!orgId) {
        console.log('No orgId provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetriccategories?orgId=${orgId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

export const fetchMetricMetadata = async (id: number) => {
    if (!id) {
        console.log('No id provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetricmetadata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

export const fetchMetricMetadataByOrg = async (orgId: number) => {
    if (!orgId) {
        console.log('No orgId provided to fetch metric metadata');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getmetadatabyorg`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ orgId }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

// fetch PercentileDist - get percentile distribution information by org and category
export const fetchPercentileDist = async (orgId: number, category: string) => {
    if (!orgId || !category) {
        console.log('No orgId or category provided to fetch metric percentile distributions');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getpercentiledist?orgId=${orgId}&category=${category}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric metadata:', error);
    }
};

// fetchPercentileById - get percentile distribution information by metric id
export const fetchPercentileById = async (metricId: number) => {
    if (!metricId) {
        console.log('No metricId provided to fetch metric percentile data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getpercentilebymetric?metricId=${metricId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching percentile data:', error);
    }
};

// fetchDistributionData - get distribution data by metric id and selected area
export const fetchDistributionData = async (metricId: number, geoDetails: GeoDetails[], geoTag: GeoTag | null) => {
    if (!metricId) {
        console.log('No metricId provided to fetch indicator distribution data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getdistributiondata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoDetails, geoTag, geoEncoding: 'delta', allowDefault: true }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching indicator distribution data:', error);
    }
};

// fetchIndicatorBinCount - get indicator data and bin count by metric id and selected area
export const fetchIndicatorBinCount = async (metricId: number, geoDetails: GeoDetails[], geoTag: GeoTag | null) => {
    if (!metricId) {
        console.log('No metricId provided to fetch indicator distribution data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getindicatorbincounts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoDetails, geoTag, geoEncoding: 'delta', allowDefault: true }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching indicator distribution data:', error);
    }
};

// fetchStateData - retreive state data for a selected metric using a prefix state code
export const fetchStateData = async (metricId: number, geoPrefix: string) => {
    if (!metricId || !geoPrefix) {
        console.log('No metricId or geoDetails provided to fetch metric state data');
        return;
    }

    console.log('geoprefix:', geoPrefix);

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getgeoprefixdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId, geoPrefix }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching metric state data:', error);
    }
};

// fetchNationalData - retreive national data for a selected metric
export const fetchNationalData = async (metricId: number) => {
    if (!metricId) {
        console.log('No metricId provided to fetch national metric data');
        return;
    }

    try {
        const response = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getgeoprefixdata`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ metricId }),
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error: any) {
        console.error('Error fetching national metric data:', error);
    }
};

export const calculateGeoPrefix = (geoDetails: GeoDetails[]): string => {
    // Flatten the geoIds array
    const geoIds = geoDetails.flatMap(geo => geo.ids);

    // Helper function to get the first two digits of a geoId
    const getGeoPrefix = (geoId: string): string => geoId.substring(0, 2);

    // Count occurrences of each prefix
    const prefixCount: Record<string, number> = {};
    geoIds.forEach(geoId => {
        const prefix = getGeoPrefix(geoId);
        prefixCount[prefix] = (prefixCount[prefix] || 0) + 1;
    });

    // Find the prefix with the highest count
    return Object.entries(prefixCount).reduce((prev, curr) => 
        curr[1] > prev[1] ? curr : prev, ['', 0]
    )[0];
};


// getMissingMetrics - utility function to check for missing metrics on a given dashboard panel
export const getMissingMetrics = (
    tab: string,
    categorizedData: Metric[],
    indicators: DisaggregatedMetric[] | null
  ): string => {
    if (!indicators) return '';
  
    const missingMetrics = indicators?.filter(metric => 
        metric.category?.toLowerCase() === tab.toLowerCase() && 
        !categorizedData.some(data => data.id === metric.id)
    ) || [];    
  
    return missingMetrics.map(metric => metric.name).join(", ");
};

// Helper function to get and sort metrics by category
export const getSortedMetrics = (category: string, categorizedData: CategorizedData) => {
    const orders = getMetricGroupOrderIds(category);

    return orders.map((order: number[]) => 
        categorizedData[category]
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
};

// Helper function to get and sort metrics by category - Used in PDF metrics display
export const getSortedMetricsPDF = (category: string, categorizedData : {
    category: string;
    metrics: DisaggregatedMetric[];
}[]): DisaggregatedMetric[] => {
    const metrics = categorizedData.find(data => data.category === category)?.metrics || [];
    const orders = getMetricGroupOrderIds(category);
    return orders.flatMap((order: number[]) =>
      metrics
        .filter(metric => order.includes(metric.id))
        .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
};
  
// Helper function to get the index metric data
export const getIndexMetricData = (
    category: string, 
    metadata: MetricMetadata[] | null, 
    disaggregatedData: DisaggregatedMetric[]
): { indexMetricId: number; indexMetricData: DisaggregatedMetric | null } => {
    
    const indexMetricId = metadata?.find(
        (metric) => 
            metric.metric_source_type === "index" && 
            metric.metric_category.toLowerCase() === category.toLowerCase()
    )?.id || 0;

    const indexMetricData = disaggregatedData.find(metric => metric.id === indexMetricId) || null;

    return { indexMetricId, indexMetricData };
};

// Helper function to get the index metric data - Formatted for PDF (MetricModal) use.
export const getIndexMetricDataPDF = (category: string, metadata: MetricMetadata[] | null, disaggregatedData: DisaggregatedMetric[]): DisaggregatedMetric | null => {
    const indexMetricId = metadata?.find(
        (metric) => metric.metric_source_type === "index" && metric.metric_category.toLowerCase() === category.toLowerCase()
    )?.id || 0;
    return disaggregatedData.find(metric => metric.id === Number(indexMetricId)) || null;
};

export const fetchCountyFips = async (locationId: string | null): Promise<GeoTag | null> => {
    try {
        const response = await fetch(import.meta.env.VITE_LOCATIONS_API_URL);
        const locations: any[] = await response.json();
        const matchingLocation = locations.find(location => location.locationId === locationId);
        
        return matchingLocation 
        ? { type: "county", value: matchingLocation.countyFips } 
        : null;
    } catch (error) {
        console.error("Error fetching county FIPS:", error);
        return null;
    }
};

export const fetchAvailableLayers = async (locationId: string | null): Promise<string | null> => {
    console.log('location id passed to fetchAvailableLayers:', locationId);
    console.log('retool endpoint:', import.meta.env.VITE_LOCATIONS_API_URL);

    try {
        const response = await fetch(import.meta.env.VITE_LOCATIONS_API_URL);
        const locations: Location[] = await response.json();
        const matchingLocation = locations.find(location => location.locationId === locationId);

        console.log('locations:', locations);
        console.log('matching location:', matchingLocation);
        
        return matchingLocation 
        ? matchingLocation.programmaticLayers 
        : null;
    } catch (error) {
        console.error("Error fetching county FIPS:", error);
        return null;
    }
};

export const fetchProgramDetailDashboardView = async (locationId: string | null): Promise<string | null> => {
    console.log('location id passed to fetchProgramDetailDashboardView:', locationId);

    try {
        const response = await fetch(import.meta.env.VITE_LOCATIONS_API_URL);
        const locations: Location[] = await response.json();
        const matchingLocation = locations.find(location => location.locationId === locationId);

        console.log('locations:', locations);
        console.log('matching location:', matchingLocation);
        
        return matchingLocation
        ? matchingLocation.programDetailView 
        : null;
    } catch (error) {
        console.error("Error fetching detail view:", error);
        return null;
    }
};

export async function getItemDetails(layerId: number, itemId: number): Promise<LayerItem | null> {
  try {
    const res = await fetch(`${import.meta.env.VITE_DASHBOARD_BACKEND_URL}/api/getlayeritemdetails?layerId=${layerId}&itemId=${itemId}`);
    if (!res.ok) {
      throw new Error(`Error ${res.status}: ${res.statusText}`);
    }

    const data = await res.json();
    console.log('item data:', data);
    return data[0] ?? null;
  } catch (err) {
    console.error('Error fetching item details:', err);
    return null;
  }
}

